import {ChangeDetectionStrategy, Component, inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {CartProduct, CustomerGroup, FileService, ListTable, StoreService, Warehouse} from 'compob2b-libs';
import {APIDefinition, Columns} from 'compob2b-table';
import {takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../../environments/translations.ru';
import {ProductService} from '../../../../product/services/product.service';
import {NbButtonModule, NbCardModule, NbCheckboxModule, NbSpinnerModule, NbWindowRef} from '@nebular/theme'
import {FormsModule} from "@angular/forms";
import {BaseModule} from "../../../../../../../../compob2b-table/lib/components/base/base.module";
import {
  ProductAvailabilityComponent
} from "../../../../product/product-list/product-availability/product-availability.component";
import {ProductPriceComponent} from "../../../../product/product-list/product-price/product-price.component";
import {SpecificationAddToCartComponent} from "../specification-add-to-cart/specification-add-to-cart.component";
import {SearchAutocompleteComponent} from "../../../../search-autocomplete/search-autocomplete.component";
import {NgIf} from "@angular/common";

@Component({
    templateUrl: './add-similar-product.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, BaseModule, NbCardModule, NbButtonModule, NbSpinnerModule, NbCheckboxModule, ProductAvailabilityComponent, ProductPriceComponent, SpecificationAddToCartComponent, SearchAutocompleteComponent, NgIf]
})

export class AddSimilarProductComponent extends ListTable implements OnInit {
  cartProductList: CartProduct[];
  requestedImportKey: string;
  submitted = false;
  checked = 0;
  readonly customerGroup$ = this.storeService.getCustomerGroup();

  productService = inject(ProductService);

  @ViewChild('table', {static: true}) table: APIDefinition;
  @ViewChild('checkboxTpl', {static: true}) checkboxTpl: TemplateRef<any>;
  @ViewChild('photoTpl', {static: true}) photoTpl: TemplateRef<any>;
  @ViewChild('headerTpl', {static: true}) headerTpl: TemplateRef<any>;
  @ViewChild('availabilityTpl', {static: true}) availabilityTpl: TemplateRef<any>;
  @ViewChild('priceTpl', {static: true}) priceTpl: TemplateRef<any>;
  @ViewChild('cartTpl', {static: true}) cartTpl: TemplateRef<any>;

  constructor(private readonly fileService: FileService,
              private readonly windowRef: NbWindowRef<CartProduct>,
              private readonly storeService: StoreService) {
    super();
  }

  ngOnInit(): void {
    this.initTableConfiguration();

    this.customerGroup$.pipe(tap(data => this.handleCustomerGroup(data)), takeUntil(this.unsubscribe)).subscribe();
  }

  private handleCustomerGroup(customerGroup: CustomerGroup) {
    this.productService.handleCustomerGroup(customerGroup);

    if (customerGroup) {
      this.columns = this.initTableColumns(customerGroup.warehouseGroup);
    }

    this.loading = false;
    this.cdr.detectChanges();
  }

  protected initTableColumns(warehouses: Warehouse[]): Columns[] {
    const columns: Columns[] = [];

    columns.push({key: 'checkbox', title: '', cellTemplate: this.checkboxTpl});
    columns.push({key: 'photo', title: translations.photo, cellTemplate: this.photoTpl});
    columns.push({key: 'header', title: translations.articulName, cellTemplate: this.headerTpl});
    columns.push(
      {key: 'manufacturerHeader', title: translations.manufacturerHeader}
    );

    if (warehouses !== undefined && warehouses.length) {
      columns.push({
        key: 'availability',
        title: translations.availability,
        cellTemplate: this.availabilityTpl
      });
    }

    columns.push({key: 'price', title: translations.priceRur, cellTemplate: this.priceTpl});
    columns.push({key: 'to_cart', title: translations.toCart, cellTemplate: this.cartTpl});
    return columns;
  }

  protected initTableConfiguration(): void {
    this.loading = true;
    this.configuration.paginationEnabled = false;
    this.configuration.orderEnabled = false;
  }

  public getImageUri(picture: string) {
    return picture ? this.fileService.getImageSrc(picture, 800) : this.noPhotoSrc;
  }

  close() {
    this.windowRef.close();
  }

  onSubmit() {
    this.windowRef.close(this.cartProductList[this.checked]);
  }
}
